import { render } from "./founder.vue?vue&type=template&id=9027e82e"
import script from "./founder.vue?vue&type=script&lang=js"
export * from "./founder.vue?vue&type=script&lang=js"

import "./founder.vue?vue&type=style&index=0&id=9027e82e&lang=css"

import exportComponent from "/home/runner/work/intelli-landing-frontend/intelli-landing-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__